import defaultSchema from './data/default';
import { DEFAULT_COUNTRY_CODE } from '../constants';

// TODO: remove static loading of IE & GB schema with dynamic loading.
import './data/IE.json';
import './data/GB.json';

const allCountries = require('./countries-en.json');

export const getDefaultCountry = () => {
  const code = DEFAULT_COUNTRY_CODE || 'IE';
  return {
    value: code,
    label: allCountries[code],
  };
};
/**
 * Returns an array of known countries and their ISO2 codes.
 */
export const getCountries = () => {
  // Promoted counties are moved to the top of the list.
  const promotedCountriesCodes = ['IE', 'GB'];

  // Some country codes appear in an order that do not correspond to the English alphabetic order,
  // so sort by actual name first before filtering
  const countryListSortedByName = Object.values(allCountries).sort((a, b) => a.localeCompare(b));
  const otherCountries = countryListSortedByName
    .filter(
      (name) =>
        !promotedCountriesCodes.includes(
          Object.keys(allCountries).find((key) => allCountries[key] === name),
        ),
    )
    .map((name) => ({
      value: Object.keys(allCountries).find((key) => allCountries[key] === name),
      label: name,
    }));

  const promotedCountries = promotedCountriesCodes.map((code) => ({
    value: code,
    label: allCountries[code],
  }));

  return [...promotedCountries, { value: '', label: '----------------' }, ...otherCountries];
};

/**
 * Returns either country-specific address schema, or default schema.
 *
 * @param {string} ISO2Code
 */
export const loadSchema = async (ISO2Code) => {
  // TODO: do we need to cache loaded schemas?
  // Gracefully fallback to the default schema if country-specific schema is
  // not found.
  try {
    const json = await import(`./data/${ISO2Code}.json`);
    return json && json.default ? json.default : json;
  } catch {
    return defaultSchema;
  }
};
